/*
 *  File: confirm.component.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { CsaService } from '../services/csa.service';
import { SearchService } from '../services/search.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: []
})
/**
 *
 * @author dlolugu1271
 * @description This component class which is used to render the
 * confirmation page after performing cancellation or creating
 * the case to customer service.
 * 
 */
export class ConfirmComponent implements OnInit {

  private commonSysErr: string;
  private appconfig = environment.appconfig;
  public loading: boolean = true;

  constructor(
    private csaService: CsaService,
    private searchService: SearchService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  /**
   *
   * @author dlolugu1271
   * @description This method will initialize the component
   * and renders the error message if any in previus page.
   * 
   */
  ngOnInit() {
    localStorage.clear();
    this.commonSysErr= '';
    if (!this.csaService.csaResp && !this.searchService.cancelResp) {
      this.router.navigate(['/error'], { relativeTo: this.route });
    }
  }
    
  /* backtosearch() {
    this.router.navigate(['/search'], { relativeTo: this.route });
  } */
}



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/confirm/confirm.component.ts